import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SvgSymbol from 'common/components/svg-symbol';
import Tab from '../tab';
import './index.scss';

/* TabBar creates a list of Tabs as a React Component. */
export default class TabBar extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    onAddTab: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.object),
    style: PropTypes.object,
    type: PropTypes.string,
    value: PropTypes.any,
  };

  static defaultProps = {
    name: null,
    options: moment.monthsShort().map((month, index) => ({
      label: month,
      value: index,
    })),
    style: {},
    type: 'underline',
    value: null,
  };

  constructor(props) {
    if (props.type !== 'sheet' && props.onAddTab) {
      throw new Error(
        'only pass onAddTab callback for TabBar where prop type="sheet"',
      );
    }

    super(props);
  }

  render() {
    const numTabs = this.props.options.length;

    // Build out list of Tabs
    const contents = this.props.options.map((datum, index) => {
      const isSelected = this.props.value === datum.value;
      const zIndex = isSelected ? numTabs + 1 : numTabs - index;

      return (
        <Tab
          dropdownMenu={datum.dropdownMenu}
          icon={datum.icon}
          isSelected={isSelected}
          key={index}
          onSelect={() => this.props.onChange(datum.value)}
          style={{zIndex}}
          title={datum.label}
          type={this.props.type}
        />
      );
    });

    // If the "name" property is specified, then include a shadowed input
    // Field that contains the value (useful for forms)
    if (this.props.name) {
      contents.push(
        <input
          key={'input'}
          name={this.props.name}
          type={'hidden'}
          value={this.props.value}
        />,
      );
    }

    // If it is a "sheet" tab bar, add a div to create a top shadow
    if (this.props.type === 'sheet') {
      // Only add a plusIcon if onAddTab prop is passed
      if (this.props.onAddTab) {
        const plusIcon = (
          <SvgSymbol
            className={'TabBar--sheet-icon'}
            key={'icon'}
            name={'plus'}
          />
        );

        const plus = (
          <span
            className={'TabBar--sheet-iconContainer'}
            key={'plusIcon'}
            onClick={this.props.onAddTab}>
            {plusIcon}
          </span>
        );

        contents.push(plus);
      }

      contents.push(
        <div
          className={'TabBar--sheet-top-shadow'}
          key={'shadow'}
          style={{zIndex: numTabs}}
        />,
      );
    }

    const classList = [];

    const baseClassName = 'TabBar';
    const typeClasses = {
      underline: 'TabBar--underline',
      month: 'TabBar--month',
      sheet: 'TabBar--sheet',
    };
    const typeClass = typeClasses[this.props.type];
    classList.push(baseClassName, typeClass);
    const className = classList.join(' ');

    return (
      <nav className={className} style={this.props.style}>
        {contents}
      </nav>
    );
  }
}
